<template>
  <h1>Chat</h1>
</template>

<script>
export default {
  name: 'Ticket'
}
</script>